import type { EmotionJSX } from '@emotion/react/types/jsx-namespace';
import type { PromoNewsletterData, SelectOption } from '@presentation/components';
import type { ReactNode } from 'react';

export interface BreedComparatorData {
  general: {
    id: number;
    img: string;
    name: string;
  }[];
  scores: {
    label?: string;
    nodes: {
      label?: string;
      values: ReactNode[] | EmotionJSX.Element[];
    }[];
  }[];
  overview: string[];
  advices: string[];
  fragilities: string[];
  morphology: string[];
  historic: string[];
}

export interface BreedCategoryItem {
  name: string;
  image?: string;
  link: string;
}

export interface BreedCategoriesData {
  breeders: BreedCategoryItem[];
  litters: BreedCategoryItem[];
}

export interface BreedComparatorPageData {
  breedOptions: SelectOption<string>[];
  formattedBreeds?: BreedComparatorData;
  formattedCategories?: BreedCategoriesData;
  showNewsletterForm?: boolean;
  newsletterForm: PromoNewsletterData;
  renderSubscribeBtn(name: string): ReactNode;
}

export interface BreedComparatorPageProps extends BreedComparatorPageData {}
